var map = {
	"./end_success.gif": "30d4",
	"./fish1.png": "bb15",
	"./fish2.png": "1926",
	"./fish3.png": "9da3",
	"./fish4.png": "626b",
	"./fish5.png": "cf32",
	"./fish6.png": "0c38",
	"./shark.png": "ef55",
	"./success.png": "412d",
	"./success_text.png": "4d71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe0e";